import { render } from "./startupsPage.vue?vue&type=template&id=7283805e"
import script from "./startupsPage.vue?vue&type=script&lang=js"
export * from "./startupsPage.vue?vue&type=script&lang=js"

import "./startupsPage.vue?vue&type=style&index=0&id=7283805e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__